import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/login.css";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (password !== confirmPassword) {
      setErrorMsg("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setErrorMsg("Password must be at least 6 characters");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`/api/reset-password/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMsg(data.message || "Password reset successful");
        setTimeout(() => navigate("/admin/login"), 2000);
      } else {
        setErrorMsg(data.message || "Link expired or invalid");
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setErrorMsg("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="adminlogin-container">
      <div className="adminlogin-left">
        <div className="adminlogin-logo">
          <img
            src="/assets/Admin_log_img.png"
            alt="Inypeople Logo"
            className="adminlogin-logo-img"
          />
        </div>
        <div className="adminlogin-illustration">
          <img src="/assets/Admin_login_img.png" alt="Inypeople" />
        </div>
        <div className="adminlogin-left-bottom">
          <h2>Almost there!</h2>
          <p>Set a new password for your account</p>
        </div>
      </div>

      <div className="adminlogin-right">
        <form className="adminlogin-form" onSubmit={handleSubmit}>
          <h1 className="adminform-heading">Reset Password</h1>
          <p className="adminform-subheading">
            Enter your new password below.
          </p>

          {errorMsg && (
            <p className="adminform-error" style={{ color: "red", marginBottom: "12px" }}>
              {errorMsg}
            </p>
          )}

          {successMsg && (
            <p className="adminform-success" style={{ color: "green", marginBottom: "12px" }}>
              {successMsg} Redirecting to login...
            </p>
          )}

          <label className="adminform-label">New Password</label>
          <div className="adminpassword-field">
            <input
              type={showPassword ? "text" : "password"}
              className="adminform-input"
              placeholder="Enter new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <img
              src="/assets/Admin_log_eye.png"
              alt="Toggle password visibility"
              className="adminpassword-eye-icon"
              onClick={() => setShowPassword((prev) => !prev)}
            />
          </div>

          <label className="adminform-label">Confirm Password</label>
          <div className="adminpassword-field">
            <input
              type={showPassword ? "text" : "password"}
              className="adminform-input"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="adminprimary-btn" disabled={isSubmitting}>
            {isSubmitting ? "RESETTING..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;